
(function() {
    'use strict';

    class GraphLegend extends window.JQX.BaseElement {
        static get properties() {
            const props = Object.assign({}, super.properties, {
                /** **graph-ref** - the graph id to connect to. Default: ''*/
                'graphRef': {
                    value: '',
                    type: 'string'
                },
                /** **is-in-edit-mode** - makes the legend non-interactive*/
                'isInEditMode': {
                    value: false,
                    type: 'boolean'
                }
            });

            return props;
        }

        findGraph() {
            return document.querySelector('ni-cartesian-graph[graph-ref=\'' + this.graphRef + '\']') ||
                document.querySelector('ni-chart[graph-ref=\'' + this.graphRef + '\']') ||
                document.querySelector('ni-intensity-graph[graph-ref=\'' + this.graphRef + '\']') ||
                // eventually the ni-control-id will have to go away
                document.querySelector('ni-cartesian-graph[ni-control-id=\'' + this.graphRef + '\']') ||
                document.querySelector('ni-chart[ni-control-id=\'' + this.graphRef + '\']') ||
                document.querySelector('ni-intensity-graph[ni-control-id=\'' + this.graphRef + '\']');
        }

        isDisabledOrInEditMode() {
            return this.disabled || this.isInEditMode;
        }

        template() {
            return '';
        }

        addDefaultClass() {
        }
    };

    NationalInstruments.HtmlVI.Elements.GraphLegend = GraphLegend;
}());
